/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OpportunityFieldData } from './OpportunityFieldData';
import {
    OpportunityFieldDataFromJSON,
    OpportunityFieldDataFromJSONTyped,
    OpportunityFieldDataToJSON,
} from './OpportunityFieldData';

/**
 * 
 * @export
 * @interface DescribeOpportunityFieldsResponse
 */
export interface DescribeOpportunityFieldsResponse {
    /**
     * 
     * @type {string}
     * @memberof DescribeOpportunityFieldsResponse
     */
    entityName: string;
    /**
     * 
     * @type {Array<OpportunityFieldData>}
     * @memberof DescribeOpportunityFieldsResponse
     */
    fields: Array<OpportunityFieldData>;
}

/**
 * Check if a given object implements the DescribeOpportunityFieldsResponse interface.
 */
export function instanceOfDescribeOpportunityFieldsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function DescribeOpportunityFieldsResponseFromJSON(json: any): DescribeOpportunityFieldsResponse {
    return DescribeOpportunityFieldsResponseFromJSONTyped(json, false);
}

export function DescribeOpportunityFieldsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DescribeOpportunityFieldsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityName': json['entityName'],
        'fields': ((json['fields'] as Array<any>).map(OpportunityFieldDataFromJSON)),
    };
}

export function DescribeOpportunityFieldsResponseToJSON(value?: DescribeOpportunityFieldsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityName': value.entityName,
        'fields': ((value.fields as Array<any>).map(OpportunityFieldDataToJSON)),
    };
}

